export default "__VITE_ASSET__5a999fdc__"